import { FC, ReactNode } from "react";

import CircularProgress from "@mui/material/CircularProgress";

import Overlay from "@/helpers/components/Overlay";

interface Props {
	text: string | Element | ReactNode;
}

export const Spinner: FC<Props> = (props) => {
	const { text } = props;

	return (
		<Overlay>
			<div
				style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					height: "100%",
					width: "100%",
					flexDirection: "column",
					color: "white", // This makes the spinner and text white
				}}
			>
				<CircularProgress color="inherit" />
				<p style={{ textAlign: "center", marginTop: "1em" }}>{text}</p>
			</div>
		</Overlay>
	);
};

export default Spinner;
